export default class DeparturePlaces {
  constructor(departurePlaces = []) {
    this._items = departurePlaces
  }

  get items() {
    return this._items
  }

  get withNamesModifiedForDisplay() {
    return new DeparturePlaces(this.items.map(d => {
      switch (d.id) {
        case 1: return { ...d, name: '東京（成田・羽田）' }  // "東京" を修正
        case 4: return { ...d, name: '大阪（関空・伊丹）' }  // "大阪" を修正
        default: return d
      }
    }))
  }

  findById(id) {
    return this.items.find(d => d.id === id)
  }

  resolveName(id) {
    const d = this.withNamesModifiedForDisplay.findById(id)
    return d && d.name || ''
  }
}
